import { SearchActions, SearchActionTypes } from '../actions/search.actions';

/**
 * OrdersState
 */
export interface SearchState {
  searchTerm: string;
}

/**
 * SEARCH_INITIAL_STATE
 * @type {{searchTerm: string}}
 */
export const SEARCH_INITIAL_STATE: SearchState = {
  searchTerm: '',
};

/**
 * searchReducer
 * @param {SearchState} state
 * @param {SearchActions} action
 * @returns {SearchState}
 */
export const searchReducer = (
  state: SearchState = SEARCH_INITIAL_STATE,
  action: SearchActions,
): SearchState => {
  switch (action.type) {
    case SearchActionTypes.LOAD_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
      };
    case SearchActionTypes.CLEAR_SEARCH_TERM:
      return {
        ...state,
        searchTerm: '',
      };
    default:
      return state;
  }
};
